import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FiMapPin, FiHome, FiSearch, FiShield, FiSquare } from 'react-icons/fi';
import "../../../css/Projects.css";
import { Navbar } from "../Navbar";
import { Helmet } from "react-helmet-async";

export const AlmostReady = () => {
  const [project, setProject] = useState(null);
  const [similarProjects, setSimilarProjects] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
     
          axios.get(`/api/almost-ready`)
              .then(res => {
                  console.log("res.data", res.data);
                  setSimilarProjects(res.data);
              })
              .catch(err => {
                  console.error("Error fetching similar projects:", err);
              });
      
  }, [project]);

  return (
       <div>
        <Helmet>
                <title>Almost Ready Projects | 24Krealtors</title>
                <meta
                  name="description"
                  content="Explore residential projects nearing completion in Chennai. Book now and move in soon with attractive offers and limited-time pricing."
                />
                <script type="application/ld+json">
                  {`
        {
          "@context": "https://schema.org",
          "@type": "ContactPage",
          "name": "Contact 24K Realtors",
          "url": "https://www.24krealtos.com/contact",
          "description": "Explore residential projects nearing completion in Chennai. Book now and move in soon with attractive offers and limited-time pricing.",
          "mainEntity": {
            "@type": "Organization",
            "name": "24k Realtors",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91-9884855955",
              "contactType": "Customer Support",
              "areaServed": "IN",
              "availableLanguage": ["English", "Tamil"]
            }
          }
        }
        `}
                </script>
              </Helmet> 
          <Navbar />
          <div className="margin"></div>
           <div className="topic1">
                        <h3 className="topic-title">
                        <span className="diamond"></span>Almost Ready Projects<span className="diamond"></span></h3>
        
                        <div className="projects-grid">
                            {Array.isArray(similarProjects) && similarProjects.map((project) => (
                                <a
                                    key={project.projectid}
                                    href={`/new-project/${project.projectid}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="property-card1"
                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                >
                                    <div className="card-image">
                                        <img src={project.image} alt={project.bpn} />
                                        <span className="badge verified "><FiShield /> Verified</span>
                                        {/* <span className="badge status">Under Construction</span> */}
                                    </div>
                                    <div className="card-content">
                                        <h3>{project.bpn}</h3>
                                        <div className="flex">
                                <p className="developer">{project.builder}</p> |
                                <p className="devr">{project.property_type}</p>
                                </div>
        
                                        <p className="icon-text">
                                            <FiMapPin /> {project.city}, {project.locality}
                                        </p>
                                        <div className='flex'>
                                          {project.property_type.toLowerCase() !== 'plot' && (
  <p className="icon-text">
    <FiHome /> {project.bhk_range
      .replace(/bhk/gi, '')
      .split(',')
      .join(' & ') + ' BHK'} |
  </p>
)}

{project.property_type.toLowerCase() === 'plot' && (
  <p className="icon-text">
    <FiSquare /> {project.measurement}: {project.starting_unit_size} - {project.end_unit_size} |
  </p>
)}
                                            <p className="icon-text">
                                                ₹{project.min_price} - ₹{project.max_price}
                                            </p>
                                        </div>
                                        <div className="card-actions">
                                            <button className="btn view">
                                                <FiSearch /> View Details
                                            </button>
        
                                        </div>
                                    </div>
                                </a>
                            ))
                            }
                        </div>
                    </div>
        </div>
        
      )
}
